import { render, staticRenderFns } from "./expertForumDetail.vue?vue&type=template&id=42fd0387&scoped=true"
import script from "./expertForumDetail.vue?vue&type=script&lang=js"
export * from "./expertForumDetail.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/articleDetail.css?vue&type=style&index=0&id=42fd0387&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fd0387",
  null
  
)

export default component.exports